/* Vue wrapped for flatpickr datepicker component.
* Added wrapper as local dependency.
* Code from: https://github.com/ankurk91/vue-flatpickr-component */

import Vue from "vue";
import "flatpickr/dist/flatpickr.css";
import flatDatepicker from './component.js';

Vue.component("flat-datepicker", flatDatepicker);
